import React, { useContext, useState } from 'react';
import styles from './Header.module.css';
import { ReactComponent as UniblLogo } from '../assets/unibl.svg';
import { ReactComponent as ETFLogo } from '../assets/etf-round-text-oglasna.svg';
import Navigation from './Navigation';
import BurgerMenuButton from './BurgerMenuButton';
import BurgerMenu from './BurgerMenu';
import { ThemeContext } from '../contexts/ThemeContext';

const Header = () => {
  const { dark } = useContext(ThemeContext);
  const [ showBurgerMenu, setShowBurgerMenu ] = useState(false);

  const toggleBurgerMenu = () => {
    setShowBurgerMenu(!showBurgerMenu);
  }

  return (
    <header className={dark?styles.headerDark:styles.headerLight}>
      <div className={styles.headerContent}>
        <BurgerMenuButton toggleBurgerMenu={toggleBurgerMenu} showBurgerMenu={showBurgerMenu}/>
        <div className={styles.logoContainer}>
          <a href='http://unibl.org/'>
            <UniblLogo className={dark?styles.headerIconDark:styles.headerIconLight} />
          </a>
          <a href='/simple'>
            <ETFLogo className={dark?styles.headerIconDark:styles.headerIconLight} />
          </a>
        </div>
        <Navigation/>
      </div>
      <div className={styles.headerContent}>
        <BurgerMenu toggleBurgerMenu={toggleBurgerMenu} showBurgerMenu={showBurgerMenu}/>
      </div>
    </header>
  );
}

export default Header;